<template>
	<div>
		<ul class="nav nav-tabs" id="myTab" role="tablist">
			<li class="nav-item" role="presentation" v-show="form.CORREO_ELECTRONICO=='1'">
				<a :class="{'nav-link':true, 'active':form.CORREO_ELECTRONICO=='1'}" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">
					Contenido Emailing
				</a>
			</li>
			<li class="nav-item" role="presentation">
				<a :class="{'nav-link':true, 'active':form.CORREO_ELECTRONICO!='1'}" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false">
					Público
				</a>
			</li>
		</ul>
		<div class="tab-content" id="myTabContent">
			<div :class="{'tab-pane fade p-3':true, 'show active':form.CORREO_ELECTRONICO=='1'}" id="profile" role="tabpanel" aria-labelledby="profile-tab" v-show="form.CORREO_ELECTRONICO=='1'">
				<h3 class="text-muted">
					Escribe el contenido para el correo electrónico.
				</h3>
				<vue-editor v-model="form.HTML"></vue-editor>

				<div class="text-right p-3">
					<button type="button" class="btn btn-link" :disabled="loadingCreate" v-on:click="cancel()">Cancelar</button>
					<button type="button" class="btn btn-primary" :disabled="loadingCreate" v-on:click="update()">
						<span v-if="loadingCreate">
							<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
							Cargando...
						</span>
						<span v-else>
							Guardar
						</span>
					</button>
				</div>
			</div>
			<div :class="{'tab-pane fade p-3':true, 'show active':form.CORREO_ELECTRONICO!='1'}" id="contact" role="tabpanel" aria-labelledby="contact-tab">
				<h3 class="text-muted text-center">
					Selecciona los clientes a los que deseas envíar
				</h3>
				<div class="bg-light p-3 rounded">
					<div class="row">
						<div class="col-md-3 mb-3">
			    			<label for="segmento">Segmento</label>
			    			<catalogo-segmentos id="segmento" v-model="form.CODIGO_SEGMENTO"></catalogo-segmentos>
						</div>
		    			<div class="col-md-4 mb-3">
		    				<label for="estado_civil">Estado civil</label>
		    				<catalogo-estado-civil id="estado_civil" v-model="form.ESTADO_CIVIL"></catalogo-estado-civil>
		    			</div>
		    			<div class="col-md-4 mb-3">
		    				<div class="custom-control custom-switch" v-if="clientesFiltered.length>0">
								<input type="checkbox" class="custom-control-input" id="all" v-model="allClientes" @change="checkToggle($event)">
								<label class="custom-control-label" for="all" v-if="allClientes">
									Deseleccionar los clientes
								</label>
								<label class="custom-control-label" for="all" v-else>
									Seleccionar los clientes
								</label>
							</div>
		    			</div>
		    			<div class="col-md-12 mb-3">
		    				<div class="input-group mt-3 mb-2">
								<div class="input-group-prepend">
									<button class="btn btn-primary" type="button" id="button-addon" v-on:click="getClientes()">
										<i class="material-icons">update</i>
									</button>
								</div>
								<input type="text" class="form-control" placeholder="Buscar" aria-label="Buscar" aria-describedby="button-addon" v-model="search">
							</div>
		    			</div>
		    		</div>
		    	</div>
	    		<div class="row">
					<div class="col-md-12">
						<div v-if="loadingClientes" class="text-center">
							<div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status">
								<span class="sr-only">Loading...</span>
							</div>
							<h3 class="text-muted">
								Cargando...
							</h3>
						</div>
						<div v-else>
							<paginacion
								:pagination="grupos"
								@paginate="getGrupos()"
								:offset="4">
							</paginacion>
							<ul class="list-group" v-if="clientesFilteredPagination.length>0">
								<li class="list-group-item d-flex justify-content-between align-items-center" v-for="cliente in clientesFilteredPagination">
									<div class="custom-control custom-switch">
										<input type="checkbox" class="custom-control-input" :id="'cliente'+cliente.CODIGO_CLIENTE" v-model="formClientes" :value="cliente.CODIGO_CLIENTE" @change="check($event, cliente.CODIGO_CLIENTE)">
										<label class="custom-control-label" :for="'cliente'+cliente.CODIGO_CLIENTE">
											{{cliente.NOMBRE_CLIENTE}}
											<div class="d-flex justify-content-between text-truncate">
												<span :class="{'badge':true, 'badge-dark':cliente.EMAIL, 'badge-danger':!cliente.EMAIL}">
													{{cliente.EMAIL || 'Sin correo'}}
												</span>
												<span :class="{'badge ml-2':true, 'badge-light':cliente.CELULAR, 'badge-danger':!cliente.CELULAR}">
													{{cliente.CELULAR || 'Sin teléfono'}}	
												</span>
											</div>
										</label>
									</div>
								</li>
							</ul>
							<div v-else>
								<empty icon="hourglass_empty" title="No hay clientes." description="No hay información relacionada a los clientes.">
								</empty>
							</div>
							<paginacion
								:pagination="grupos"
								@paginate="getGrupos()"
								:offset="4">
							</paginacion>
						</div>
					</div>
				</div>
				<div class="text-right p-3">
					<button type="button" class="btn btn-link" :disabled="loadingCreate" v-on:click="cancel()">Cancelar</button>
					<button type="button" class="btn btn-primary" :disabled="loadingCreate" v-on:click="update(true)">
						<span v-if="loadingCreate">
							<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
							Cargando...
						</span>
						<span v-else>
							Guardar
						</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js"
	export default {
		props: ['evento'],
		components: { VueEditor },
		data(){
			return {
				allClientes: true,
				loadingClientes: false,
				loadingCreate: false,

				clientes: [],
				errors: {},
				search: '',
				formClientes: [],
				form: {
					CODIGO_CAMPANA: '',
					CODIGO_CLIENTE: '',
					CODIGO_CORPORACION: '',
					CODIGO_EVENTO: '',
					CODIGO_SEGMENTO: '',
					CORREO_ELECTRONICO: '',
					ESTADO_CIVIL: '',
					HTML: '',
					SEGMENTO_MAILCHIMP: '',
					SMS: '',
					TITULO: '',
					WHATSAPP: ''
				},
				grupos: {
					per_page: 100,
					current_page: 1,
					to: 1,
					last_page: 0
				}
			}
		},

		mounted(){
			this.getClientes()
			this.form = this.eventoDF
		},

		methods: {
			getGrupos(){
				this.grupos.last_page = Math.round(this.clientesFiltered.length/(this.grupos.per_page <= 0 ? 1 : this.grupos.per_page))
			},
			check(ev, code=0){
				//this.loadingClientes = true
				axios.post('api/campanas/eventos/'+this.eventoDF.CODIGO_EVENTO+'/clientes',{
					clientes: [code],
					type: ev.target.checked
				}).then(res => {
					if (ev.target.checked) {
						this.$toasted.show('Asignado')
					}else{
						this.$toasted.show('Desasignado')
					}
					//this.clientes = res.data
					//this.selectClientes()
				}).catch(err => {
					if (ev.target.checked) {
						this.$toasted.show('Error al asignar')
					}else{
						this.$toasted.show('Error al Desasignar')
					}
					//console.log('Error al cargar')
				}).then(()=>{
					//this.loadingClientes = false
				})
			},
			checkToggle(ev){
				var dd = this.clientesFilteredCodigo
				if (ev.target.checked == true) {
					this.formClientes = this.formClientes.concat(dd)
				}else{
					this.formClientes = this.formClientes.filter(function(value, index){
						return dd.findIndex(x => x == value) == -1
					})
				}
				//this.loadingClientes = true
				axios.post('api/campanas/eventos/'+this.eventoDF.CODIGO_EVENTO+'/clientes',{
					//clientes: this.clientesFilteredCodigo,
					type: ev.target.checked,
					segmento: this.segmentoDF,
					estadoCivil: this.estadoCivilDF,
					search: this.search
				}).then(res => {
					if (ev.target.checked) {
						this.$toasted.show('Asignados')
					}else{
						this.$toasted.show('Desasignados')
					}
					//this.clientes = res.data
					//this.selectClientes()
				}).catch(err => {
					//console.log('Error al cargar')
				}).then(()=>{
					//this.loadingClientes = false
				})
			},
			selectClientes(){
				if (this.clientesFiltered.length>0) {
					return this.formClientes = this.clientesFiltered.filter(x => x.CLIENTE_EVENTO > 0).map(x => x.CODIGO_CLIENTE)
				}
				return []
			},
			cancel(){
				this.$emit('cancel', true)
			},
			getClientes(){
				this.loadingClientes = true
				axios.post('api/campanas/clientes',{
					code: this.eventoDF.CODIGO_EVENTO,
				}).then(res => {
					this.clientes = res.data
					this.selectClientes()
				}).catch(err => {
					console.log('Error al cargar')
				}).then(()=>{
					this.loadingClientes = false
				})
			},
			update(cancel=false){
				this.loadingCreate = true
				axios.put(`api/campanas/eventos/${this.form.CODIGO_EVENTO}`, this.form).then(res =>{
					var data = res.data
					this.$toasted.show('Información actualizada')
					if (cancel) {
						this.cancel()
					}
					//this.form.code = data.CODIGO_EVENTO || -1
				}).catch(err=>{
					this.$toasted.show('Error al actualizar')
					console.log(err.response)
				}).then(() => {
					this.loadingCreate = false
				})
			},
		},

		computed:{
			eventoDF(){
				return this.evento || {}
			},
			clientesFiltered(){
				var data = this.clientes

				if(this.segmentoDF){
					data = data.filter(x => x.CODIGO_SEGMENTO == this.segmentoDF)
				}
				if(this.estadoCivilDF){
					data = data.filter(x => x.ESTADO_CIVIL == this.estadoCivilDF)
				}

				if (this.search!='') {
					data = data.filter(x => (
						(x.NOMBRE_CLIENTE || '').toString().toUpperCase().includes(this.search.toUpperCase()) ||
						(x.EMAIL || 'Sin correo').toString().toUpperCase().includes(this.search.toUpperCase()) ||
						(x.CELULAR || 'Sin teléfono').toString().toUpperCase().includes(this.search.toUpperCase())
					))
				}

				return data
			},
			clientesFilteredCodigo(){
				return this.clientesFiltered.map(x => x.CODIGO_CLIENTE)
			},
			clientesFilteredPagination(){
				return this.clientesFiltered.slice(((this.grupos.current_page-1)*this.grupos.per_page), (this.grupos.current_page*this.grupos.per_page))
			},
			segmentoDF(){
				return this.form.CODIGO_SEGMENTO
			},
			estadoCivilDF(){
				return this.form.ESTADO_CIVIL
			},
		},

		watch:{
			eventoDF(val){
				this.form = val
			},
			formClientes(val){
				var dd = this.clientesFilteredCodigo
				var v = val.filter(function(value, index){
					return dd.findIndex(x => x == value) != -1
				})
				this.allClientes = v.length == dd.length ? true : false
			},
			clientesFiltered(val){
				var dd = this.clientesFilteredCodigo
				var v = this.formClientes.filter(function(value, index){
					return dd.findIndex(x => x == value) != -1
				})
				this.allClientes = v.length == dd.length ? true : false
				this.grupos.current_page = 1
				this.getGrupos()
			}
		}
	}
</script>
<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";

@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.bubble.css';
@import '~quill/dist/quill.snow.css';
</style>